import * as React from "react";
import { ui } from "../../../../contracts";
export class ToggleOddsBtn extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClickHandler = (e) => {
            e.stopPropagation();
            this.props.onClick();
        };
        this.setTooltipMsg = ui.TooltipApi.getInstance().setMessage.bind(this);
        this.btnRef = React.createRef();
    }
    componentDidUpdate() {
        if (this.btnRef.current) {
            ui.TooltipApi.getInstance().refresh(this.btnRef.current);
        }
    }
    render() {
        const tooltip = this.setTooltipMsg(this.props.tooltipMessage);
        return (React.createElement("div", Object.assign({ ref: this.btnRef, className: `rj-ev-list__toggle-odds-btn rj-ev-list__toggle-odds-btn--${this.props.toggled}`, onClick: this.onClickHandler }, tooltip, { "data-uat": "div-ev-list-toggle-odds-btn" }),
            React.createElement("span", { className: "icon i-14 i-o-ev-up-down" })));
    }
}
//# sourceMappingURL=ToggleOddsBtn.js.map